import { Stack, Typography, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';

export default function TablePaginationBar({ total, page, pageCount, limit, onChange }) {
    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" sx={{ mt: 2 }} spacing={1}>
            <Typography variant="body2">Total: <b>{total}</b> • Page <b>{page}</b>/<b>{pageCount}</b></Typography>
            <Stack direction="row" spacing={1} alignItems="center">
                <FormControl size="small"><InputLabel>Par page</InputLabel>
                    <Select value={limit} label="Par page" onChange={(e) => onChange({ limit: e.target.value, page: 1 })}>
                        {[10,20,50,100].map(n => <MenuItem key={n} value={n}>{n}</MenuItem>)}
                    </Select>
                </FormControl>
                <Button disabled={page <= 1} onClick={() => onChange({ page: Math.max(1, page - 1) })}>Précédent</Button>
                <Button disabled={page >= pageCount} onClick={() => onChange({ page: Math.min(pageCount, page + 1) })}>Suivant</Button>
            </Stack>
        </Stack>
    );
}
